'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Utils = function () {
	function Utils(options) {
		_classCallCheck(this, Utils);

		this.host = options.host;
	}

	_createClass(Utils, [{
		key: 'createEnvelope',
		value: function createEnvelope(id, type, payload) {
			return {
				id: id,
				type: type,
				host: this.host,
				payload: payload
			};
		}
	}]);

	return Utils;
}();

var options = {
	host: (window.location || {}).host
};

var utils = new Utils(options);

var IframeDispatcher = function () {
	function IframeDispatcher() {
		_classCallCheck(this, IframeDispatcher);

		this.callbacks = {};
	}

	_createClass(IframeDispatcher, [{
		key: 'send',
		value: function send(envelope, complete) {
			this.dispatchMessage('event', envelope, complete);
		}
	}, {
		key: 'sendCallback',
		value: function sendCallback(messageId) {
			var envelope = utils.createEnvelope(messageId);
			this.dispatchMessage('callback', envelope, function () {});
		}
	}, {
		key: 'triggerCallback',
		value: function triggerCallback(id, call) {
			var _this = this;

			// Alerts within JS callbacks will sometimes freeze the iOS app.
			// Let's wrap the callback in a timeout to prevent this.
			setTimeout(function () {
				if (_this.callbacks[id]) {
					_this.callbacks[id](call);
				} else {
					console.warn('### Callback not present inside IframeDispatcher.triggerCallback ###', { id: id, cbs: _this.callbacks });
				}
			}, 0);
		}

		// `type` can either be "event" or "callback"

	}, {
		key: 'dispatchMessage',
		value: function dispatchMessage(type, envelope, complete) {
			var _this2 = this;

			// We send the message by navigating the browser to a special URL.
			// The iOS library will catch the navigation, prevent the UIWebView
			// from continuing, and use the data in the URL to execute code
			// within the iOS app.
			this.callbacks[envelope.id] = function (call) {
				if (call) {
					complete();
				}
				delete _this2.callbacks[envelope.id];
			};
			var encodedEnvelope = encodeURIComponent(JSON.stringify(envelope));
			var src = 'jockey://' + type + '/' + envelope.id + '?' + encodedEnvelope;
			var iframe = document.createElement('iframe');
			iframe.setAttribute('src', src);
			document.documentElement.appendChild(iframe);
			iframe.parentNode.removeChild(iframe);
			iframe = null;
		}
	}]);

	return IframeDispatcher;
}();

var NativeDispatcher = function () {
	function NativeDispatcher(jockey) {
		_classCallCheck(this, NativeDispatcher);

		this.jockey = jockey;
		this.callbacks = {};
	}

	_createClass(NativeDispatcher, [{
		key: 'send',
		value: function send(envelope, complete) {
			this.dispatchMessage('jockeyEvent', envelope, complete);
		}
	}, {
		key: 'sendCallback',
		value: function sendCallback(messageId) {
			var envelope = utils.createEnvelope(messageId);
			this.dispatchMessage('jockeyCallback', envelope, function () {});
		}
	}, {
		key: 'triggerCallback',
		value: function triggerCallback(id, call) {
			if (this.callbacks[id]) {
				this.callbacks[id](call);
			} else {
				console.warn('### Callback not present inside NativeDispatcher.triggerCallback ###', { id: id, cbs: this.callbacks });
			}
		}

		// `type` can either be "jockeyEvent" or "jockeyCallback"

	}, {
		key: 'dispatchMessage',
		value: function dispatchMessage(type, envelope, complete) {
			var _this3 = this;

			this.callbacks[envelope.id] = function (call) {
				if (call) {
					complete();
				}
				delete _this3.callbacks[envelope.id];
			};
			this.jockey.targetWindow.postMessage({ type: type, envelope: envelope }, this.jockey.targetDomain);
		}
	}]);

	return NativeDispatcher;
}();

var Jockey = function () {
	function Jockey() {
		_classCallCheck(this, Jockey);

		this.listeners = {};
		this.dispatchers = [];
		this.messageCount = 0;
		this.targetDomain = '*';
		this.targetWindow = window.parent;

		var iOS = false;
		var iDevices = ['iPad', 'iPhone', 'iPod'];
		for (var i = 0; i < iDevices.length; i += 1) {
			var iDevice = iDevices[i];
			if ((navigator.platform || '').indexOf(iDevice) >= 0) {
				iOS = true;
				break;
			}
		}
		// Detect UIWebview. In Mobile Safari proper, jockey urls cause a popup to
		// be shown that says "Safari cannot open page because the URL is invalid."
		// From here: http://stackoverflow.com/questions/4460205/detect-ipad-iphone-webview-via-javascript
		var UIWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
		var isAndroid = (navigator.userAgent || '').toLowerCase().indexOf('android') > -1;
		if (iOS && UIWebView || isAndroid) {
			this.dispatchers.push(new NativeDispatcher(this));
		}
		this.dispatchers.push(new IframeDispatcher());
		if (window.addEventListener) {
			window.addEventListener('message', this.onMessageRecieved, false);
		}
	}

	_createClass(Jockey, [{
		key: 'on',
		value: function on(type, fn) {
			if (!{}.hasOwnProperty.call(this.listeners, type) || !(this.listeners[type] instanceof Array)) {
				this.listeners[type] = [];
			}
			this.listeners[type].push(fn);
		}
	}, {
		key: 'off',
		value: function off(type) {
			if (!{}.hasOwnProperty.call(this.listeners, type) || !(this.listeners[type] instanceof Array)) {
				this.listeners[type] = [];
			}
			this.listeners[type] = [];
		}
	}, {
		key: 'send',
		value: function send(type, payload, complete) {
			/* eslint-disable no-param-reassign */
			if (payload instanceof Function) {
				complete = payload;
				payload = null;
			}

			payload = payload || {};
			var fallback = function fallback() {};
			complete = complete || fallback;
			/* eslint-enable no-param-reassign */
			var envelope = utils.createEnvelope(this.messageCount, type, payload);

			this.dispatchers.forEach(function (dispatcher) {
				dispatcher.send(envelope, complete);
			});

			this.messageCount += 1;
		}

		// hack to make Android work nice with encoded json...

	}, {
		key: 'decodeAndTrigger',
		value: function decodeAndTrigger(type, messageId, encodedJson) {
			var json = window.atob ? window.atob(encodedJson) : '{}';
			this.trigger(type, messageId, JSON.parse(json));
		}

		// Called by the native application when events are sent to JS from the app.
		// Will execute every function, FIFO order, that was attached to this event type.

	}, {
		key: 'trigger',
		value: function trigger(type, messageId, json) {
			var _this4 = this;

			var listenerList = this.listeners[type] || [];

			var executedCount = 0;

			var complete = function complete() {
				executedCount += 1;

				if (executedCount >= listenerList.length) {
					_this4.dispatchers.forEach(function (dispatcher) {
						dispatcher.sendCallback(messageId);
					});
				}
			};

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = listenerList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var listener = _step.value;

					// If it's a "sync" listener, we'll call the complete() function
					// after it has finished. If it's async, we expect it to call complete().
					if (listener.length <= 1) {
						listener(json);
						complete();
					} else {
						listener(json, complete);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}

		// Called by the native application in response to an event sent to it.
		// This will trigger the callback passed to the send() function for
		// a given message.

	}, {
		key: 'triggerCallback',
		value: function triggerCallback(id) {
			// only call complete inside triggerCallback for the first dispatcher
			// since there is a bug when multiple dispatchers are present -> callback is called for each dispatcher
			// which is weird since we only called the this.send method once
			// (but hey, smarter people than me probably know why)
			this.dispatchers.forEach(function (dispatcher, idx) {
				dispatcher.triggerCallback(id, idx === 0);
			});
		}
	}, {
		key: 'restrictIframeDispatcher',
		value: function restrictIframeDispatcher(targetDomain, targetWindow) {
			this.targetDomain = targetDomain;
			this.targetWindow = targetWindow;
		}

		// Handles postMessage events when iframeDispatcher is used

	}, {
		key: 'onMessageReceived',
		value: function onMessageReceived(event) {
			if (this.targetDomain !== '*' && this.targetDomain !== event.origin) {
				return;
			}

			var envelope = event.data.envelope;
			if (event.data.type === 'jockeyEvent') {
				this.trigger(envelope.type, envelope.id, envelope.payload);
			} else if (event.data.type === 'jockeyCallback') {
				this.triggerCallback(event.data.envelope.id);
			}
		}
	}]);

	return Jockey;
}();

var jockey = new Jockey();

window.Jockey = jockey;

exports.default = jockey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/zender-js/dist/jockey/index.js
// module id = 563
// module chunks = 0